import { css } from '@emotion/react'
import { typo } from '@mathflat/common/style'

const S = {
  row: css`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-height: 40px;
    .toggle {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
      .label-group {
        display: flex;
        align-items: center;
        gap: 4px;
        > .tooltip-wrap {
          margin-left: 0;
        }
      }
      .label {
        color: var(--Colors-Gray-900);
        font-weight: 600;
        ${typo.body02};
      }
    }
    .controls {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
    }
    .fields {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    /* 예약됨 텍스트와 연필 버튼 사이는 날짜·시간 필드 사이(8px)보다 좁은 4px */
    .fields.reserved-fields {
      gap: 4px;
    }
    .reserved {
      color: var(--Colors-Gray-900);
      ${typo.body02};
    }
    .error {
      color: var(--Colors-Red-500);
      ${typo.caption01};
    }
  `,
  datePicker: css`
    width: 130px;
  `,
  tooltip: css`
    white-space: pre-line;
  `,
}

export default S
